import { ApiPropertyOptional } from '@nestjs/swagger';
import { IsDateString, IsOptional, IsString, IsUUID, IsNumber } from 'class-validator';

/**
 * Editar cabecera de rendición. Solo aplicable en estado BORRADOR.
 */
export class UpdateRendicionViaticoDto {
  @ApiPropertyOptional() @IsOptional() @IsUUID() empleado_id?: string;
  @ApiPropertyOptional() @IsOptional() @IsString() concepto?: string;
  @ApiPropertyOptional() @IsOptional() @IsDateString() fecha_inicio?: string;
  @ApiPropertyOptional() @IsOptional() @IsDateString() fecha_fin?: string;
  @ApiPropertyOptional() @IsOptional() @IsUUID() moneda_id?: string;
  @ApiPropertyOptional() @IsOptional() @IsNumber() cotizacion?: number;
  @ApiPropertyOptional() @IsOptional() @IsString() observaciones?: string;
}
